<kilowant-header [isHome]="true" [title]="(showJoinWhiteList)?'Join Waitlist':'Sign Up'" linkHome="/"></kilowant-header>
@if (pageLoaded()) {
<div [class]="(!showPrivateText)?'move-hide':'t0'">
    <div class="overWrapper register-page">
        <div class="wrapper-main-public-area base-register">
            @if (showJoinWhiteList) {
            <div class="mt-20">
                <div class="form">
                    <input type="text" name="name" value="" (input)="resetError('name')" [(ngModel)]="name" [disabled]="registrationCompleted" placeholder="Name" [class]="(errorY().isWrong('name'))?'error':''" />
                    <div class="cols">
                        <div class="col">
                            <input type="text" name="city" value="" (input)="resetError('city')" [disabled]="registrationCompleted" [(ngModel)]="city" placeholder="City" [class]="(errorY().isWrong('city'))?'error':''" />
                        </div>
                        <div class="col">
                            <select name="state" [(ngModel)]="state" [disabled]="registrationCompleted" [class]="(errorY().isWrong('state'))?'error':''" (input)="resetError('state')">
                                <option [ngValue]="null" [selected]="true" [disabled]="true">ST</option>
                                @for (state of allStates(); track state) {
                                <option [value]="state.id">{{state.stateCode}}</option>
                                }
                            </select>
                        </div>
                    </div>

                    <input type="text" name="email" value="" (input)="resetError('email')" [disabled]="registrationCompleted" [(ngModel)]="email" placeholder="Email address" [class]="(errorY().isWrong('email'))?'error':''" />
                    @if (this.errorY().showError() && waitlistForm) {
                    <div class="error-block">{{errorY().error}}</div>
                    }
                    <button type="button" class="bottom highlighted-button" [disabled]="registrationCompleted" (click)="trackButtonClick('join_waitlist'); joinWeblistSubmit()">Join</button>
                </div>
            </div>
            }
            <div class="clear"></div>
            @if (!showJoinWhiteList && !registrationCompleted) {
            <div class="form">
                <div class="card">
                    <div class="body">
                        <div class="table-view">
                            <div class="row">
                                <div class="cell">
                                    <input type="text" name="FirstName" [class]="getClassesForInput('FirstName', true, user.firstName)" (input)="resetError('FirstName')" placeholder="First name" [(ngModel)]="user.firstName" [minlength]="validationService.getMinLength('User', 'firstName')" [maxlength]="validationService.getMaxLength('User', 'firstName')" />
                                    @if (getVisibilityForLabel(user.firstName)) {
                                    <div class="placeholder">First name</div>
                                    }
                                </div>
                                <div class="cell">
                                    <input type="text" name="LastName" [class]="getClassesForInput('LastName', true, user.lastName)" (input)="resetError('LastName')" placeholder="Last name" [(ngModel)]="user.lastName" [minlength]="validationService.getMinLength('User', 'lastName')" [maxlength]="validationService.getMaxLength('User', 'lastName')" />
                                    @if (getVisibilityForLabel(user.lastName)) {
                                    <div class="placeholder">Last name</div>
                                    }
                                </div>
                            </div>
                        </div>
                        <input type="text" name="Company" [class]="getClassesForInput('Company', true, companyName)" (input)="resetError('Company')" placeholder="Company (optional)" [(ngModel)]="companyName" [minlength]="validationService.getMinLength('Company', 'name')" [maxlength]="validationService.getMaxLength('Company', 'name')" />
                        @if (getVisibilityForLabel(companyName)) {
                        <div class="placeholder">Company(optional)</div>
                        }
                        <div>
                            <input type="text"
                                   name="addressLine1"
                                   [class]="getClassesForInput('addressLine1', true, user.addressLine1)"
                                   (input)="resetError('addressLine1')"
                                   placeholder="Address Line"
                                   [(ngModel)]="user.addressLine1"
                                   [minlength]="validationService.getMinLength('User', 'address')"
                                   [maxlength]="validationService.getMaxLength('User', 'address')" />
                            @if (getVisibilityForLabel(user.addressLine1)) {
                            <div class="placeholder">Address Line</div>
                            }

                            <div class="cols">
                                @if (cityStateShow() || (user.city!=null && user.city.length>0)) {
                                <div class="col auto">
                                    <input type="text" name="City" [value]="user.city" [disabled]="true" class="placeholder" />
                                    <div class="placeholder">City</div>
                                </div>
                                }
                                @if (cityStateShow() || (user.state!=null)) {
                                <div class="col">
                                    <input type="text" name="State" style="width: 60px;" [value]="getStateName(user.state)" [disabled]="true" class="placeholder" />
                                    <div class="placeholder">State</div>
                                </div>
                                }
                                <div class="col" [class]="(cityStateShow() || user.state!=null)?'':'auto'">
                                    <input type="text"
                                           name="address"
                                           [class]="getClassesForInput('zip', true, user.zip)"
                                           (input)="zipChanged()"
                                           [style]="(cityStateShow() || user.state!=null)?'width: 70px;':''"
                                           placeholder="Zip"
                                           [(ngModel)]="user.zip"
                                           [minlength]="validationService.getMinLength('User', 'zip')"
                                           [maxlength]="validationService.getMaxLength('User', 'zip')" />
                                    @if (getVisibilityForLabel(user.zip)) {
                                    <div class="placeholder">Zip</div>
                                    }
                                </div>
                            </div>

                            @if (user.state!=null && user.state.stateCode!='RI') {
                            <div class="mb-10">* kilowant is currently active in the RI Energy service territory. If you are not a RI Energy customer, we will notify you when kilowant becomes available in your region.</div>
                            }
                        </div>
                        <div class="table-view">
                            <div class="row">
                                <div class="cell">
                                    <input type="text" name="Email" [class]="getClassesForInput('Email', true, user.email)" (input)="resetError('Email')" placeholder="Email" [(ngModel)]="user.email" [minlength]="validationService.getMinLength('User', 'email')" [maxlength]="validationService.getMaxLength('User', 'email')" />
                                    @if (getVisibilityForLabel(user.email)) {
                                    <div class="placeholder">Email</div>
                                    }
                                </div>
                                <div class="cell">
                                    <input type="text" name="Phone"
                                           [class]="getClassesForInput('Phone', true, (((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'1':'')))"
                                           (input)="resetError('Phone')"
                                           placeholder="Mobile Phone"
                                           [dropSpecialCharacters]="false"
                                           [formControl]="currentPhoneNumber"
                                           (focus)="focusField('Phone')"
                                           mask="(000) 000-0000"
                                           [showMaskTyped]="(focusedField()=='Phone')||(currentPhoneNumber.value!=null && currentPhoneNumber.value?.trim()!='' && !currentPhoneNumber.value.valid)" />
                                    @if (getVisibilityForLabel(((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'phone':''))) {
                                    <div class="placeholder">Mobile Phone</div>
                                    }
                                </div>
                            </div>
                        </div>
                        <input [type]="passwordType" name="Password" [class]="getClassesForInput('Password', true, password)" (input)="resetError('Password')" placeholder="Password" [(ngModel)]="password" [minlength]="validationService.getMinLength('User', 'password')" [maxlength]="validationService.getMaxLength('User', 'password')" />
                        @if (getVisibilityForLabel(password)) {
                        <div class="placeholder">Password</div>
                        }
                        <div class="password-holder" (click)="showPassword(1)">
                            <i [class]="(passwordType=='password')?'password-show':'password-hide'"></i>
                        </div>
                        <input [type]="passwordType2" name="Password2" [class]="getClassesForInput('Password2', true, password)" (input)="resetError('Password2')" placeholder="Password (confirm)" [(ngModel)]="password2" [minlength]="validationService.getMinLength('User', 'password')" [maxlength]="validationService.getMaxLength('User', 'password')" />
                        @if (getVisibilityForLabel(password2)) {
                        <div class="placeholder">Password (confirm)</div>
                        }
                        <div class="password-holder" (click)="showPassword(2)">
                            <i [class]="(passwordType2=='password')?'password-show':'password-hide'"></i>
                        </div>
                        @if (errorY().showError() && !waitlistForm) {
                        <div class="error-block">{{errorY().error}}</div>
                        }
                        <div class="p-1 f14 ac">
                            Your personal information will be protected and managed in accordance with our <a routerLink="/privacy-policy">Privacy Policy</a>.
                        </div>
                        <button type="button" class="bottom highlighted-button mt-3" (click)="trackButtonClick('sign_up'); sendForm(3)">Sign Up</button>
                    </div>
                </div>
            </div>
            }
            @if (registrationCompleted) {
            <div class="text-block mt-20">
                <p class="logo-upper-text">Thank you for joining</p>
                <div class="logo-grey-join"></div>
                <div class="form=">
                    <div class="card without-margin">
                        <p class="text-center">
                            An email has been sent to<br />
                            <span class="blue"><u>{{user.email}}</u>. Please click on the link included in your email to activate your user account.</span> If you have not received our email, please check your spam folder.
                        </p>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>
}